import { DateTime } from 'luxon'

export default () => {
  const { ToAttachment } = useMappers()
  const article = useArticle()

  const pdfs = ref<any[]>([])
  const audios = ref<any[]>([])
  const videos = ref<any[]>([])
  const badges = reactive<string[]>([])

  watchEffect(() => {
    pdfs.value = ToAttachment(article.value.attachments?.data, 'pdf')
    audios.value = ToAttachment(article.value.attachments?.data, 'audio')
    videos.value = ToAttachment(article.value.attachments?.data, 'video')

    badges.splice(0, badges.length)

    if (article.value.publishedAt) {
      badges.push(DateTime.fromISO(article.value.publishedAt).setLocale('sk').toFormat('d. MMMM yyyy'))
    }

    if (article.value.author?.fullName) {
      badges.push(article.value.author.fullName)
    }

    if (article.value.readTime) {
      badges.push(article.value.readTime)
    }
  })

  return { pdfs, audios, videos, badges }
}
